import urls from "../../../urls";
import type { MeteringOrMarketLocation } from "../../../utils/backend-types";
import { MEDIUM_CHOICES } from "../../../utils/constants";
import { Frequency, MeasurementType, Medium } from "../../../utils/enums";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";

export const MARKET_LOCATION_FORM_FIELD_DATA = {
  number: {
    name: "number",
    label: "Marktlokationsnummer",
    type: "text",
    required: true
  },
  customLabel: {
    name: "customLabel",
    label: "Bezeichnung",
    type: "text"
  },
  commissioning: {
    name: "commissioning",
    type: "date",
    required: false,
    label: "Inbetriebnahme der Lokation",
    helpText:
      "Datum der Inbetriebnahme der Lokation wie mitgeteilt durch den Messstellenbetreiber. Wird gegebenenfalls durch node.energy nach Rückmeldung des Messstellenbetreibers ausgefüllt. Standardmäßig vorbefüllt mit der ältesten Inbetriebnahme der EE-Anlagen, die zu dieser Lokation gehören."
  },
  decommissioning: {
    name: "decommissioning",
    type: "date",
    required: false,
    label: "Außerbetriebnahme der Lokation",
    helpText:
      "Datum der Außerbetriebnahme der Lokation wie mitgeteilt durch den Messstellenbetreiber. Wird gegebenenfalls durch node.energy nach Rückmeldung des Messstellenbetreibers ausgefüllt. Standardmäßig vorbefüllt mit der aktuellsten Außerbetriebnahme der EE-Anlagen, die zu dieser Lokation gehören."
  },
  meteringServiceProvider: {
    name: "meteringServiceProvider",
    label: "Messstellenbetreiber",
    type: "async-select",
    placeholder: "Name oder Marktpartneridentifikationsnummer",
    dataUrl: urls.api.meteringServiceProviders()
  },
  medium: {
    name: "medium",
    label: "Medium",
    type: "select",
    data: MEDIUM_CHOICES,
    defaultValue: Medium.Electricity,
    required: true
  },
  frequency: {
    name: "frequency",
    label: "Intervall der Messwerte",
    type: "select",
    data: [
      { label: "10 Minuten", value: "10min" },
      { label: "Viertelstunde", value: "15min" },
      { label: "Stunde", value: "hour" },
      { label: "Tag", value: "day" },
      { label: "Monat", value: "month" },
      { label: "Jahr", value: "year" }
    ],
    defaultValue: Frequency.QuarterHour,
    required: true
  },
  measurementType: {
    name: "measurementType",
    label: "Erfassung der Energiemengen",
    type: "select",
    data: [
      { label: "Lastgang", value: "lastgang" },
      { label: "Zählerstandsgang", value: "zählerstandsgang" }
    ],
    defaultValue: MeasurementType.Single,
    required: true
  },
  status: {
    name: "status",
    label: "Status",
    type: "select",
    helpText:
      "Beschreibt den Status der Lokation innerhalb dieser Liegenschaft. Inaktive Lokationen werden weder bei der Erstellung der Vollmachts-Vorlage noch bei der Anfrage nach Energiedaten beim Messstellenbetreiber berücksichtigt.",
    data: [
      { label: "aktiv", value: "active" },
      { label: "inaktiv", value: "inactive" }
    ],
    required: true
  },
  comment: {
    name: "comment",
    label: "Kommentar",
    type: "text",
    helpText:
      "Frei wählbar, kann insbesondere genutzt werden um weitere Informationen bei einen Statuswechsel bereitzustellen."
  }
} as const satisfies {
  [key in keyof MeteringOrMarketLocation]?: FormInputData<
    MeteringOrMarketLocation,
    key
  >;
};
